var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basehead'),_vm._m(0),_c('div',{staticClass:"container"},[_c('ExperienceTypeChooser',{staticClass:"card-group",attrs:{"institution_filter":"all"}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('h2',{staticClass:"col-md-9 m-auto"},[_vm._v("Experiments")])])
}]

export { render, staticRenderFns }